import {createSlice} from "@reduxjs/toolkit";

const initialState = {
  entities: [],
  error: null,
};
export const callTypes = {
  data: "data",
  action: "action"
};

export const slice = createSlice({
  name: "popupCreateReceipt",
  initialState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
    },
    startCall: (state, action) => {
      state.error = null;
    },
  }
});
